import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2fb7c4bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "track_page_head" }
const _hoisted_2 = { class: "track_page_body" }
const _hoisted_3 = { class: "trackActionModal__map" }
const _hoisted_4 = { class: "market-wrap flex-row" }
const _hoisted_5 = { class: "flex-row" }
const _hoisted_6 = { class: "line-box flex-row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line line-red" }, null, -1))
const _hoisted_8 = { class: "line-box flex-row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line line-green" }, null, -1))
const _hoisted_10 = {
  id: "mapContainer",
  ref: "mapContainerRef"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_user_input = _resolveComponent("app-user-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_app_car_input = _resolveComponent("app-car-input")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_Detail = _resolveComponent("Detail")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    class: "utils__pageContainer trackList",
    title: "车辆轨迹"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_form, {
          class: "fl-clean autoList__filterForm",
          form: _ctx.filterParams,
          layout: 'inline'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "员工" }, {
              default: _withCtx(() => [
                _createVNode(_component_app_user_input, {
                  value: _ctx.filterParams.staffKeyword,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterParams.staffKeyword) = $event)),
                  class: "filterInput",
                  "is-need-user-info": true,
                  onGetUserInfo: _ctx.getUserInfo
                }, null, 8, ["value", "onGetUserInfo"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "车牌" }, {
              default: _withCtx(() => [
                _createVNode(_component_app_car_input, {
                  value: _ctx.filterParams.vehicleKeyword,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterParams.vehicleKeyword) = $event)),
                  class: "filterInput"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "日期" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_date_picker, {
                  value: _ctx.filterParams.objDate,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterParams.objDate) = $event)),
                  type: "date",
                  placeholder: "日期",
                  style: {"width":"100%"},
                  "value-format": "YYYY-MM-DD",
                  "disabled-date": _ctx.disabledDate
                }, null, 8, ["value", "disabled-date"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  ghost: "",
                  onClick: _ctx.onRefreshTrack
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("查询")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["form"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("span", null, "实际行驶 " + _toDisplayString(_ctx.trackInfo.realDistance) + " （公里）", 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("span", null, "推荐路线 " + _toDisplayString(_ctx.trackInfo.recommendDistance) + " （公里）", 1)
              ])
            ]),
            _createElementVNode("div", {
              class: "detail-btn",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.visible = true))
            }, "详情>>>")
          ]),
          _createElementVNode("div", _hoisted_10, null, 512)
        ])
      ]),
      _createVNode(_component_Detail, {
        visible: _ctx.visible,
        "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.visible) = $event)),
        "track-info": _ctx.trackInfo
      }, null, 8, ["visible", "track-info"])
    ]),
    _: 1
  }))
}